import { Controller } from "@hotwired/stimulus"

// Key used to store the password temporarily in sessionStorage
const SESSION_STORAGE_KEY = "crypto_unlock_key"

// Captures the password on login submit and stores it temporarily in sessionStorage
// so it can later be used for client-side WebCrypto decryption of the RSA private key.
// The password must be cleared from sessionStorage immediately after use.
export default class LoginController extends Controller {
  connect(): void {
    this.element.addEventListener("submit", this.handleSubmit)
  }

  disconnect(): void {
    this.element.removeEventListener("submit", this.handleSubmit)
  }

  private handleSubmit = (event: Event): void => {
    const form = event.target as HTMLFormElement
    const passwordInput = form.querySelector<HTMLInputElement>('input[type="password"]')

    if (passwordInput?.value) {
      sessionStorage.setItem(SESSION_STORAGE_KEY, passwordInput.value)
    }
  }
}
